import Dropdown from './dropdown'
const plugin = {
    install: Vue => {
        Vue.component(Dropdown.name, Dropdown)
    }
}

Dropdown.install = plugin.install
export default Dropdown



// WEBPACK FOOTER //
// ./src/components/dropdown/index.js